import React from 'react'

import { Container, Grid, Button } from '@toptal/picasso'

import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { mergeRequested } from '../../actions'

interface IProps {
  label: string
  onClick(event: React.MouseEvent): void
}

export const MergeButton: React.FunctionComponent<IProps> = ({
  label,
  onClick
}) => {
  return (
    <Container top='medium' bottom='medium'>
      <Grid justify='center'>
        <Grid.Item small={12} medium={2}>
          <Button variant='success' onClick={onClick} fullWidth={true}>
            {label}
          </Button>
        </Grid.Item>
      </Grid>
    </Container>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onClick: () => dispatch(mergeRequested())
})

const MergeButtonSmart = connect(
  null,
  mapDispatchToProps
)(MergeButton)

export default MergeButtonSmart
